import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import IndexPage from '../pageComponents/IndexPage';
import SiteLayout from '../components/SiteLayout';
import { withBreakpoints } from '../components/Boneyard';
import CookiesDisabledMessage from '../components/CookiesDisabledMessage';

const Index = () => {
  const [areCookiesEnabled, setAreCookiesEnabled] = useState(undefined);
  const router = useRouter();

  useEffect(() => {
    let cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    setAreCookiesEnabled(cookieEnabled);
  }, []);

  useEffect(() => {
    const storedData = JSON.parse(window.localStorage.getItem('userDetails'));

    if (storedData?.forceResetPasswordFlag) {
      router.push(
        `/updatepassword${window.location.search}${window.location.hash}`
      );
    }
  }, [router]);

  // only check cookies on the client side
  if (typeof window !== 'undefined') {
    if (!areCookiesEnabled) {
      return <CookiesDisabledMessage />;
    }
  }

  return (
    <SiteLayout title="Home">
      <IndexPage />
    </SiteLayout>
  );
};

export default withBreakpoints(Index);
